module.exports = "<div dir={{dir}} class=\"main__wrapper\">\n  <main class=\"main-container\"> \n    <router-outlet></router-outlet>\n  </main>\n</div>"